exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gu-mirror {\n  position: fixed !important;\n  margin: 0 !important;\n  z-index: 9999 !important;\n  opacity: 0.8;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=80)\";\n  filter: alpha(opacity=80);\n}\n.gu-hide {\n  display: none !important;\n}\n.gu-unselectable {\n  -webkit-user-select: none !important;\n  -moz-user-select: none !important;\n  -ms-user-select: none !important;\n  user-select: none !important;\n}\n.gu-transit {\n  opacity: 0.2;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=20)\";\n  filter: alpha(opacity=20);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/css-loader?{"sourceMap":false,"importLoaders":1}!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/postcss-loader?{"ident":"postcss"}!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/dragula/dist/dragula.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../dragula/dist/dragula.css
// module chunks = 3